const QuestionModel = [
  {
    field: 'alcohol_sexAssignedAtBirth',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false },
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    }
  },
  {
    field: 'alcohol_pregnancyStatus',
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'alcohol_consentPregnancy',
    label: 'Consent (pregnancy):',
    type: 'select',
    educationalSlide:
      'I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.\n\nI agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.\n\nI understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.\n\nBy selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and do NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'alcohol_heightFeet',
    label: 'What is your height in feet and inches?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'alcohol_heightFeet'
    }
  },
  {
    field: 'alcohol_weightPounds',
    label: 'What is your weight in pounds?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'alcohol_weightPounds'
    }
  },
  {
    field: 'alcohol_consentAbruptDiscontinuation',
    label: 'Consent (Abrupt Alcohol Discontinuation Risk):',
    type: 'select',
    educationalSlide:
      'You are seeking an intervention to help reduce cravings for alcohol use. Abruptly stopping alcohol can lead to severe and potentially life‑threatening withdrawal symptoms. Please read carefully to understand more about the risks and abruptly stopping alcohol and developing a plan to reduce use gradually.\n\nEligibility Criteria:\nSelf‑directed tapering is intended only for individuals who:\n• Experience only mild to moderate withdrawal symptoms when reducing alcohol\n• Have no prior history of seizures or delirium tremens\n• Maintain stable physical and mental health\n• Are medically stable and are not undergoing evaluation or treatment of an uncontrolled medical condition\n• Have reliable social support and a safe home environment\n\nIf you do not meet these criteria, you agree to pursue medically supervised withdrawal instead.\n\nPotential Risks:\nReducing or stopping alcohol can lead to withdrawal, which in severe cases may include:\n• Confusion or hallucinations\n• Intense shaking\n• Rapid heartbeat or fever\n• Seizures\n• Serious life threatening complications and/or death\n\nThese risks can be life‑threatening. You should seek immediate medical care if they occur.\n\nPatient Responsibilities:\nYou agree to:\n\nTrack Intake & Symptoms\n• Maintain a daily log of drinks and withdrawal symptoms.\n• Use a checklist or diary and review it each evening.\n\nTaper Plan\n• Reduce alcohol by approximately 5–10% per week (e.g., if you consume 10 drinks daily, decrease by 1 drink per day for a week before decreasing again by 1 drink the following week).\n• Pause the taper and seek help if withdrawal symptoms become too severe.\n\nSupport & Monitoring\n• Check in with a designated support person at least once daily for the first week after your last drink.\n• Use community or online support groups as needed.\n\nSelf‑Care Measures\n• Stay hydrated, eat balanced meals, and engage in low‑stress activities.\n\nWhen to Seek Professional Help:\nContact emergency services or your healthcare provider immediately if you experience:\n• Severe shaking, confusion, or hallucinations\n• Fever, rapid heartbeat, or seizure activity\n• Overwhelming cravings or inability to adhere to your taper plan\n• Thoughts of self‑harm or dramatic mood changes\n\nAcknowledgement & Consent:\nBy signing below, you confirm that you have read and understand the information above. You agree to follow the outlined plan and recognize when to seek medical assistance. You understand that self‑weaning carries risks and that your safety is your top priority.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do not wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'alcohol_programGoal',
    label: 'What is your goal with this program?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I need to cut down on my drinking',
          key: 'cut_down'
        },
        {
          value: 'People in my life have asked me to reduce my drinking',
          key: 'others_asked'
        },
        {
          value:
            'At times, I feel guilty about drinking and I would like to stop',
          key: 'feel_guilty'
        },
        {
          value: 'I have other reason(s) that are not listed above',
          key: 'other'
        }
      ]
    }
  },
  {
    field: 'alcohol_programGoalOther',
    label: 'Please explain more regarding your other goals',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'alcohol_programGoalOther'
    }
  },
  {
    field: 'alcohol_issuesDuration',
    label: 'How long have you been experiencing issues with your alcohol use?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '<1 year', key: 'less_than_1' },
        { value: '1-5 years', key: '1_to_5' },
        { value: '>5 years', key: 'more_than_5' }
      ]
    }
  },
  {
    field: 'alcohol_withdrawalHistory',
    label: 'Have you ever experienced alcohol withdrawal before?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'alcohol_withdrawalComplications',
    label:
      'Have you ever had complications from alcohol withdrawal including hospitalization, rapid heart rate, hallucinations, seizures, delirium tremens?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'alcohol_recentAbstinence',
    label:
      'Have you gone without alcohol for 5 or more days WITHIN the last 6?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'alcohol_withdrawalSymptoms',
    label:
      'Did you experience any alcohol withdrawal symptoms during that time?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'alcohol_consumptionChange',
    label: 'Has your alcohol consumption changed since then?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: "Yes, I'm drinking more", key: 'more' },
        { value: "Yes, I'm drinking less", key: 'less' },
        { value: "No, I'm drinking about the same amount", key: 'same' }
      ]
    }
  },
  {
    field: 'alcohol_weekdayDrinks',
    label: 'How many drinks do you consume per weekday?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '1-3 drinks per day', key: '1_to_3' },
        { value: '4-5 drinks per day', key: '4_to_5' },
        { value: '6-10 drinks per day', key: '6_to_10' },
        { value: '11 or more drinks per day', key: '11_plus' }
      ]
    }
  },
  {
    field: 'alcohol_weekendDrinks',
    label: 'How many drinks do you consume per weekend day?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '1-3 drinks per day', key: '1_to_3' },
        { value: '4-5 drinks per day', key: '4_to_5' },
        { value: '6-10 drinks per day', key: '6_to_10' },
        { value: '11 or more drinks per day', key: '11_plus' }
      ]
    }
  },
  {
    field: 'alcohol_cravingTime',
    label: 'What time do your cravings begin?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'As soon as I wake up', key: 'wake_up' },
        { value: 'A few hours after I wake up', key: 'few_hours' },
        { value: 'Later in the day or afternoon', key: 'later' }
      ]
    }
  },
  {
    field: 'alcohol_medicalConditions',
    label:
      'Have you been diagnosed with any of the following conditions? Please choose all that apply.',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Obstructive Sleep Apnea', key: 'sleep_apnea' },
        {
          value: 'Chronic Kidney Disease (CKD Stage 3B or greater)',
          key: 'ckd'
        },
        { value: "Parkinson's Disease", key: 'parkinsons' },
        { value: 'Uncontrolled Diabetes', key: 'diabetes' },
        { value: 'Unstable Heart Condition', key: 'heart' },
        {
          value:
            'Unstable Respiratory Problems (Asthma, COPD/Emphysema) which require oxygen or hospitalization within the last 12 months',
          key: 'respiratory'
        },
        { value: 'Liver cirrhosis/elevated liver enzymes', key: 'liver' },
        { value: 'Problems Urinating', key: 'urinating' },
        { value: 'Inherited Metabolic Diseases', key: 'metabolic' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'alcohol_sleepApneaControl',
    label:
      'Have you been prescribed a CPAP machine that you use consistently and is your sleep apnea well controlled?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'My sleep apnea is well controlled with CPAP, oral device, or another intervention',
          key: 'controlled'
        },
        {
          value:
            'My sleep apnea has been resolved by lifestyle or surgical intervention',
          key: 'resolved'
        },
        {
          value: 'My sleep apnea is not controlled', // Disqualify if LineItem is baclofen
          key: 'not_controlled'
        }
      ]
    }
  },
  {
    field: 'alcohol_naltrexoneContraindications',
    label: 'Do you have any of the following? (Check all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',

      options: [
        ///If any of the above are true, disqualify from naltrexone use if offered
        {
          value: 'Currently receiving opioid pain medication',
          key: 'opioid_meds'
        },
        {
          value: 'Current physiologic opioid dependence',
          key: 'opioid_dependence'
        },
        { value: 'Acute opioid withdrawal', key: 'opioid_withdrawal' },
        {
          value:
            'History of hypersensitivity or side effects to naltrexone (or VIVITROL)',
          key: 'naltrexone_sensitivity'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'alcohol_baclofenContraindications',
    label: 'Do you have any of the following? (Check all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        // If any of the above are true, disqualify from baclofen use if offered
        { value: 'Uncontrolled Psychiatric Illness', key: 'psychiatric' },
        { value: 'History of stroke', key: 'stroke' },
        { value: 'Epilepsy or history of seizures', key: 'seizures' },
        {
          value: 'History of hypersensitivity or side effects to baclofen',
          key: 'baclofen_sensitivity'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'alcohol_additionalQuestions',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'alcohol_additionalQuestions'
    }
  },
  {
    field: 'alcohol_consentTruthfulness',
    label: 'Consent (Truthfulness):',
    type: 'select',
    educationalSlide:
      'Please attest to the following confirming that all information you have provided to us is true and complete.\n\nI verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do not wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'alcohol_consentPharmacotherapy',
    label:
      'Consent (Pharmacotherapy to Reduce Alcohol Cravings (Naltrexone or Baclofen)):',
    type: 'select',
    educationalSlide:
      'Please read the following information to understand the potential benefits and risks of either naltrexone or baclofen for reducing cravings for alcohol. These medications are intended to support your efforts to cut back on drinking and maintain safer, healthier habits.\n\nIndication for Use:\nYou are considering treatment with naltrexone or baclofen as part of a comprehensive plan to reduce alcohol cravings and support decreased alcohol use.\n\n• Naltrexone works by blocking opioid receptors involved in the reward pathways of alcohol, helping to lessen the pleasurable effects of drinking and reduce the urge to drink.\n• Baclofen is a muscle relaxant that acts on GABA‑B receptors in the brain, which may help curb the reinforcing effects of alcohol and decrease cravings.\n\nPotential Benefits:\n• Reduced intensity and frequency of alcohol cravings\n• Decreased overall alcohol consumption\n• Support for longer periods of abstinence or low‑risk drinking\n• Improvement in mood, sleep, and daily functioning as drinking decreases\n\nPotential Side Effects:\n\nNaltrexone\n• Common: Nausea, headache, dizziness, fatigue\n• Less Common but Serious: Elevated liver enzymes or liver injury (especially at higher doses); allergic reactions\n\nBaclofen\n• Common: Drowsiness or sedation, dizziness, weakness, nausea\n• Less Common but Serious: Confusion, respiratory depression (at high doses), potential for baclofen withdrawal if stopped abruptly\n\nRisks and Considerations:\n• Naltrexone should not be used if you are currently on opioids or have acute hepatitis or significant liver impairment. Inform your provider of any opioid use (including for pain or opioid replacement therapy).\n• Baclofen requires caution if you have kidney impairment (dose adjustment may be necessary) or a history of seizure disorders. Abrupt discontinuation can lead to serious withdrawal symptoms, including increased anxiety, insomnia, or seizures.\n• Certain medical conditions or medications may make one or both drugs unsuitable for you; please discuss your full medical history, including any pregnant or breastfeeding status, with your provider.\n\nMonitoring and Follow‑Up:\n• Regular check‑ins to assess cravings, side effects, and medication adherence\n• Dose adjustments based on effectiveness and tolerability\n• Ongoing engagement with counseling, support groups, or other psychosocial interventions\n\nAcknowledgment & Consent:\nBy signing below, you acknowledge that you have read and understood the information about naltrexone and baclofen, including their mechanisms, potential benefits, side effects, risks, and monitoring requirements. You agree to proceed with the prescribed medication plan and to maintain scheduled follow‑up appointments for safe and effective treatment.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do not wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    class: 'ineligible',
    field: 'alcohol_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    isLast: true,
    answer: {}
  },
  {
    field: 'alcohol_complete',
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    extras: { sendToBeluga: false },
    isLast: true,
    answer: {}
  }
] as const;

export default QuestionModel;
